<template>
  <div id="customers-list-forward">
    <vs-popup title="Encaminhar para" @close="closePopUp" :active.sync="isActive">
      <vs-table
        search
        ref="table"
        :sst="true"
        :data="customers"
        :max-items="itemsPerPage"
        @search="handleSearch"
        id="customers-list-forward"
        noDataText="Sem dados disponíveis"
      >
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bgcursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">
                {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                {{customers.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : customers.length }} of {{ queriedItems }}
              </span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage=4">
                <span>4</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=20">
                <span>20</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot-scope="{data}">
          <tbody>
            <div :key="index" v-for="(tr, index) in data" class="flex">
              <vs-checkbox v-model="selected" :vs-value="tr.id"/>

              <div class="contact__avatar mr-1">
                <vs-avatar v-if="tr.image" class="border-2 border-solid border-white" :src="tr.image" size="42px"/>
                <vs-avatar v-else class="border-2 border-solid border-white" size="42px" />
              </div>
              <div class="align-self-center items-center">
                <div class="flex">
                  <h5 class="font-semibold ml-1" id="adjust-customer-name" :style="{float: 'left'}"> {{ tr.name }} </h5>
                  <feather-icon v-if="tr.is_favorite" icon="StarIcon" svgClasses="h-4 w-4" class="cursor-pointer ml-2" style="color: #faff00;"/>
                </div>
                <span>{{ maskPhoneNumber(tr.phone_number) }}</span>
              </div>
            </div>
          </tbody>
        </template>
      </vs-table>

      <vs-pagination class="mt-1" :total="totalPages" v-model="currentPage" :max="5"/>

      <vs-button color="primary" type="filled" class="align-right mr-5 mb-4" style="float: right; margin-top: 3em;" @click="forwardMessage">
        Encaminhar
      </vs-button>
    </vs-popup>
  </div>
</template>

<script>
import VsDropdownItem from "@/components/vs-dropdown/dropdown-item.vue";
import VsDropdownMenu from "@/components/vs-dropdown/dropdown-menu.vue";
import TagComponent from "@/components/group-of-customer/Tag.vue";
import moduleCustomer from '@/store/customer/moduleCustomer'
import {encodeToBase64, generateHash, instanceObject, maskPhoneNumber} from "@/utils";
import moment from "moment";
import {CustomerChatService} from "@/db/customerChat_service";

export default {
    name: 'customers-list-forward',
    emits: ['isActiveFalse'],
    components: {TagComponent, VsDropdownMenu, VsDropdownItem},
    props: {
      isActive: {
        type: Boolean,
        required: true
      },
      customerChat: {
        required: true,
        validator: prop => typeof prop === 'object' || prop === null
      }
    },
    data() {
      return {
        objects: [],
        selected: [],
        popupActivated: false,
        currentPage: 1,
        itemsPerPage: 4,
        isMounted: false,
        searchQuery: '',
        ccService: null
      }
    },
    watch: {
      isActive(value) {
        if (!value) {
          this.objects = [];
          this.selected = [];
          this.currentPage = 1;
          this.itemsPerPage = 4;
          this.popupActivated = false
        }
      },
      currentPage: function() {
        this.fetchCustomers()
      },
      itemsPerPage: function() {
        this.currentPage = 1
        this.fetchCustomers()
      },
      selected(value){
        if (value.lenght === 0){
          this.objects = [];
          return;
        }

        this.objects = this.objects.filter(obj => value.includes(obj.id));
        value.forEach(id => {
          if (!this.objects.some(obj => obj.id === id)) {
            const customer = this.customers.find(customer => customer.id === id);
            if (customer) {
              this.objects.push({
                id: customer.id,
                name: customer.name,
                phone_number: customer.phone_number,
                hasOpenCosts: customer.hasOpenCosts,
                isBeingAttendedBy: customer.isBeingAttendedBy
              });
            }
          }
        });
      }
    },
    computed: {
      customers() {
        return this.$store.state.customer.customers ? this.$store.state.customer.customers.items : []
      },
      queriedItems() {
        return this.$store.state.customer.customers ? this.$store.state.customer.customers.total_items : 0
      },
      totalPages() {
        return this.$store.state.customer.customers ? this.$store.state.customer.customers.total_pages : 1
      },
      activeUser() {
        return this.$store.state.AppActiveUser
      }
    },
    methods: {
      maskPhoneNumber,
      async handleSearch(searchQuery) {
        this.currentPage = 1
        this.searchQuery = searchQuery
        await this.fetchCustomers()
      },
      async fetchCustomers() {
        await this.$store.dispatch("customer/fetch", {
          pagination_limit: this.itemsPerPage,
          pagination_page: this.currentPage,
          search_query: this.searchQuery,
          deleted_at: null
        });
      },
      validateCustomers(){
        const instance = instanceObject(this.customerChat.instance_id);
        if (instance && instance.is_official){
          const notCostsOpen = this.objects.filter(customer => !customer.hasOpenCosts.includes(this.customerChat.instance_id));
          if ( notCostsOpen.length > 0 ){
            this.$vs.notify({
              time: 7000,
              color: 'warning',
              title: 'Contatos sem atendimentos abertos!',
              text: `Os contatos '${notCostsOpen.map(customer => customer.name).join(', ')}' não possuem atendimentos abertos nas últimas 24horas nessa conexão cloud.`,
            });

            return false;
          }
        }

        const differentUser = this.objects.filter((customer) => {
          if (customer.isBeingAttendedBy && customer.isBeingAttendedBy.length > 0){
            return customer.isBeingAttendedBy.some(attendant => (attendant.user_id && attendant.user_id !== this.activeUser.id && attendant.instance_id === this.customerChat.instance_id && this.$store.getters["instance/chosenInstanceIds"].includes(attendant.instance_id)));
          }
          return false;
        });

        if ( differentUser.length > 0 ){
          this.$vs.notify({
            time: 7000,
            color: 'warning',
            title: 'Contatos possuem atendimentos com outros usuários!',
            text: `Os contatos '${differentUser.map(customer => customer.name).join(', ')}' possuem conversas ativas vinculados a outros usuários.`,
          });

          return false;
        }

        const inbox = this.objects.filter((customer) => {
          if (customer.isBeingAttendedBy && customer.isBeingAttendedBy.length > 0){
            return customer.isBeingAttendedBy.some(attendant => (!attendant.user_id && attendant.instance_id === this.customerChat.instance_id && this.$store.getters["instance/chosenInstanceIds"].includes(attendant.instance_id)));
          }
          return false;
        });

        if ( inbox.length > 0 ){
          this.$vs.notify({
            time: 7000,
            color: 'warning',
            title: 'Contatos possuem atendimentos na caixa de entrada!',
            text: `Os contatos '${inbox.map(customer => customer.name).join(', ')}' possuem conversas ativas na caixa de entrada.`,
          });

          return false;
        }

        return true;
      },
      async forwardMessage() {
        try {
          if ( !this.validateCustomers() ){
            return;
          }

          let skiped = false;
          this.objects.forEach((customer) => {
            const currentTime = new Date();
            const hash = generateHash(customer.id, this.customerChat.message, this.activeUser.id, this.customerChat.instance_id);

            if (this.customerChat.tag_type === 'ptt') {
              this.$store.dispatch("chatContact/sendChatAudio", {
                customerId : customer.id,
                toNumber   : customer.phone_number,
                fileUrl    : this.customerChat.message,
                fileCaption: '',
                instanceId : this.customerChat.instance_id,
                userId     : this.activeUser.id,
                hash       : hash,
                timeout    : 25
              }).catch((error) => {
                console.error(error)
                this.$vs.notify({
                  time: 7000,
                  color: 'danger',
                  title: 'Houve um problema no encaminhamento da mensagem',
                  text: `Ocorreu um erro ao enviar a mensagem para o contato ${customer.name}. Tente enviar a mensagens novamente em alguns instantes.`,
                });
              })
            } else if (this.customerChat.tag_type === 'sticker') {
              this.$store.dispatch("chatContact/sendChatSticker", {
                customerId  : customer.id,
                toNumber    : customer.phone_number,
                imageUrl    : this.customerChat.message,
                instanceId  : this.customerChat.instance_id,
                userId      : this.activeUser.id,
                hash        : hash,
                timeout     : 25
              }).catch((error) => {
                console.error(error)
                this.$vs.notify({
                  time: 7000,
                  color: 'danger',
                  title: 'Houve um problema no encaminhamento da mensagem',
                  text: `Ocorreu um erro ao enviar a mensagem para o contato ${customer.name}. Tente enviar a mensagens novamente em alguns instantes.`,
                });
              })
            } else if (['image', 'document', 'video', 'doc', 'pdf'].includes(this.customerChat.tag_type)) {
              this.$store.dispatch("chatContact/sendChatImage", {
                customerId  : customer.id,
                toNumber    : customer.phone_number,
                imageUrl    : this.customerChat.message,
                imageCaption: '',
                instanceId  : this.customerChat.instance_id,
                userId      : this.activeUser.id,
                hash        : hash,
                timeout     : 25
              }).catch((error) => {
                console.error(error)
                this.$vs.notify({
                  time: 7000,
                  color: 'danger',
                  title: 'Houve um problema no encaminhamento da mensagem',
                  text: `Ocorreu um erro ao enviar a mensagem para o contato ${customer.name}. Tente enviar a mensagens novamente em alguns instantes.`,
                });
              })
            } else if (['stop_flow', 'chat', 'flow'].includes(this.customerChat.tag_type)) {
              this.$store.dispatch("chatContact/sendChatMessage", {
                customerId    : customer.id,
                toNumber      : customer.phone_number,
                message       : encodeToBase64(this.customerChat.message),
                instanceId    : this.customerChat.instance_id,
                userId        : this.activeUser.id,
                replyMessageId: '',
                hash          : hash,
                timeout       : 15
              }).catch((error) => {
                console.error(error)
                this.$vs.notify({
                  time: 7000,
                  color: 'danger',
                  title: 'Houve um problema no encaminhamento da mensagem',
                  text: `Ocorreu um erro ao enviar a mensagem para o contato ${customer.name}. Tente enviar a mensagens novamente em alguns instantes.`,
                });
              })
            } else {
              skiped = true;
              return;
            }

            let indexedMsg = {
              id              : 88888 * currentTime.getMilliseconds(),
              customer_id     : customer.id,
              type            : 0,
              sent_at         : moment(new Date()).format('YYYY-MM-DD') + ' ' + currentTime.toLocaleTimeString(undefined, { hour12: false }),
              tag_type        : 'stop_flow',
              is_temp         : 1,
              hash            : hash,
              ack             : 0,
              replyMessageId  : null,
              instance_id     : this.customerChat.instance_id,
              user_sending_id : this.activeUser.id
            }

            if ( ['stop_flow', 'chat', 'flow'].includes(this.customerChat.tag_type) ){
              indexedMsg['message'] = this.customerChat.message
            } else {
              indexedMsg['message'] = this.customerChat.message;
              indexedMsg['tag_type'] = this.customerChat.tag_type;
              indexedMsg['document_name'] = this.customerChat.document_name;
            }

            this.ccService.insert([indexedMsg], false, true);
            this.$events.fire('RefreshObserverChatData', indexedMsg);
          });

          if (skiped){
            return
          }

          this.$vs.notify({
            color: 'success',
            title: 'Mensagem encaminhada!',
            text: 'Mensagem encaminhada com sucesso!'
          })
        } catch (error) {
          console.log(error)
          this.$vs.notify({
            color: 'danger', 
            title: 'Erro ao encaminhar mensagem!',
            text: error
          })
        }

        this.selected = [];
        this.$emit('isActiveFalse');
      },
      closePopUp() {
        this.isActive = false;
        this.$emit('isActiveFalse');
      }
    },
    created() {
      if (!moduleCustomer.isRegistered) {
        this.$store.registerModule('customer', moduleCustomer)
        moduleCustomer.isRegistered = true
      }

      this.searchQuery = '';
      this.ccService = new CustomerChatService();
      this.fetchCustomers()
    },
    async mounted() {
      this.isMounted = true;
    }
  }
</script>

<style lang="scss">
  #customers-list-forward {
    .vs-con-tbody{
      background: none !important;
      border: none !important;
    }
  }
</style>